exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ng-valid[required], .ng-valid.required {\n  border-left: 5px solid #42A948; }\n\n.ng-invalid {\n  border: 1px; }\n\nselect.ng-invalid {\n  border: 1px solid #a11919; }\n\n.noinfo {\n  border-bottom: 1px solid #dddbda; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/corporate-action/other-action/other-action.component.scss
// module id = ../../../../../src/app/securities-level/corporate-action/other-action/other-action.component.scss
// module chunks = main